import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import '../index.scss'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Row, Col, Alert, Modal, Button, Form, Input, Checkbox, message } from 'antd'
import { graphql, withApollo } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {

	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			confirmDirty: false,
		}
	}

	handleOnSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveNewPassword } = this.props

		form.validateFields((err, values) => {
			if (err) {
				AuthStore.setError('Please Fill All Fields')
				return false
			}
			this.setState({ isSaving: true }, () => {
				saveNewPassword(values)
					.then((response) => {
						message.success('Credentials successfully updated.')
						this.setState({ isSaving: false }, () => {
							AuthStore.setIsPasswordChanged(true)
							window.location.href = '/'
						})
					})
					.catch(err => {
						console.log('error saving new password', err)
						this.setState({ isSaving: false })
						message.error(err.message.replace('GraphQL error:',''))
					})
			})
		})
	}
	
	handleConfirmBlur = (e) => {
    	const value = e.target.value
    	this.setState({ confirmDirty: this.state.confirmDirty || !!value })
	}
    
    compareToFirstPassword = (rule, value, callback) => {
    	const form = this.props.form
    	if (value && value !== form.getFieldValue('new_password')) {
    		callback('Two passwords that you enter is inconsistent!')
    	} else if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
    		callback('only white space detected.')
    	} else {
    		callback()
    	}
    }

    validateToNextPassword = (rule, value, callback) => {
    	const form = this.props.form
    	if (value && this.state.confirmDirty) {
    		form.validateFields(['confirm_passowrd'], { force: true })
    	} else if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
    		callback('only white space detected.')
    	}
    	callback()
    }

    render() {
    	const { isSaving } = this.state
    	const { form, AuthStore } = this.props
    	const { getFieldDecorator, getFieldValue, resetFields } = form
    	const { userDetails, toArray } = AuthStore
		
    	const mUserDetails = toArray(userDetails)
    	const hasUsername = mUserDetails && mUserDetails.username

    	return (
    		<React.Fragment>
    			<Row type='flex' justify='center' style={{ background: '#FFFFFF' }}>
    				<div className='changepassword-box'>
    					<Row type='flex' justify='center' style={{ marginBottom: '30px' }}>
    						<Col>
    							<Link to='/'>
    								<h2 style={{ color: 'gray' }}>Change Your Password</h2>
    							</Link>
    						</Col>
    					</Row>
    					<Form onSubmit={this.handleOnSubmit.bind(this)}>
    						{
    							!hasUsername &&
								<Row className='form-email'>
									<Form.Item label='Username'>
										{ getFieldDecorator('username', {
											rules: [{
												required: true,
												message: 'This field is required.'
											}, {
												validator: (rule, value, callback) => {
													if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
														callback('only white space detected.')
													}
													callback()
												}
											}]
										})
										(
											<Input maxLength={32} placeholder='Username here'/>
										)}
									</Form.Item>
								</Row>
    						}
    						{
    							!hasUsername && <hr/>
    						}
    						<Row className='form-email'>
    							<Form.Item label='Update Password'>
    								{ getFieldDecorator('new_password', {
    									rules: [{
    										required: true,
    										message: 'This field is required.'
    									}, {
    										validator: this.validateToNextPassword
    									}]
    								})
    								(
    									<Input.Password maxLength={32} placeholder='Password here'/>
    								)}
    							</Form.Item>
    						</Row>
    						<Row className='form-email'>
    							<Form.Item label='Confirm Password'>
    								{ getFieldDecorator('confirm_password', {
    									rules: [{
    										required: true,
    										message: 'This field is required.'
    									}, {
    										validator: this.compareToFirstPassword
    									}]
    								})
    								(
    									<Input.Password onBlur={this.handleConfirmBlur} maxLength={32} placeholder='Password here'/>
    								)}
    							</Form.Item>
    						</Row>
    						{/* <Row className='form-email'>
    							<Form.Item label=''>
    								{ getFieldDecorator('checked_privacy', {
    									rules: [{
    										required: false,
    										//message: 'This field is required.'
    									}]
    								})
    								(
    									<Checkbox>
											By creating an account you agree to our <a href='#'>Privacy Policy</a>.
    									</Checkbox>
    								)}
    							</Form.Item>
    						</Row> */}
    						<Row className='form-btn-submit'>
    							<Button 
    								// disabled={!getFieldValue('checked_privacy')}
    								type='primary' 
    								block 
    								size='large'
    								className='ctm_btn_round'
    								onClick={this.handleOnSubmit.bind(this)}
    								loading={isSaving}
    							>
									Update Now
    							</Button>
    						</Row>
    					</Form>
    				</div>
    			</Row>
    		</React.Fragment>
    	)
    }
}

const updatePassword = gql`
	mutation updatePassword ($input: JSON) {
		updatePassword (input: $input)
	}
`

const composed = compose(
	withRouter,
	Form.create({ name: 'changepassword-form' }),
	inject('AuthStore'),
	graphql(updatePassword, {
		props({ mutate }) {
			return {
				saveNewPassword(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['allRooms']
					})
				}
			}
		}
	}),
	observer,
)

export default composed(Index)
